import { signInWithPopup } from './popup'
import { CredentialProvider } from './types'

export const facebookProvider: CredentialProvider<void> = {
  id: 'facebook',

  authenticate() {
    return signInWithPopup('facebook', firebase => {
      const provider = new firebase.auth.FacebookAuthProvider()

      provider.addScope('email')
      provider.addScope('public_profile')
      provider.setCustomParameters({ display: 'popup' })

      return provider
    })
  }
}
